// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h5-Ta","inputsRow":"styles_inputsRow__xSgOA","label":"styles_label__DbPiv"};